import React, {useEffect} from 'react';
import {NextSeo} from 'next-seo';
import SpecialistDoctorNavDetails from '@components/SpecialistDoctor/SpecialistDoctorNavDetails';
import SpecialistDoctorDetails from '@components/SpecialistDoctor/SpecialistDoctorDetails';
import RelatedDoctors from '@components/SpecialistDoctor/RelatedDoctors';
import DoctorCustomerComments from '@components/SpecialistDoctor/DoctorCustomerComments';

export default function SpecialistDoctorDetailPage(props) {
    const {seoPage} = props;

    return (
        <div>
            {seoPage && <NextSeo {...seoPage} />}
            <SpecialistDoctorNavDetails doctor={props.preloadedDoctor} />
            <SpecialistDoctorDetails {...props} />
            <DoctorCustomerComments {...props} />
            <RelatedDoctors {...props} />
        </div>
    );
}

SpecialistDoctorDetailPage.PageName = 'SPECIALLIST-DOCTOR-DETAILS';
